import { object, string } from 'yup';

export const schema = object({
  locale: string().matches(
    /^[A-Za-zÁÉÍÓÚÂÊÎÔÛÀÈÌÒÙÃÕÇáéíóúâêîôûàèìòùãõç\s]+$/,
    'Apenas são letras e espaços permitidos'
  )
});
